import styled from 'styled-components';

export default comp => styled(comp)`
  a {
    &[href^='tel'], &.underline {
      color: ${props => props.theme.colors.claytonBlue};

      &:focus,
      &:hover,
      &:active {
        color: ${props => props.theme.colors.bigSky};
      }
    }
  }
  .button-link {
    width: max-content;
  }

  .color-claytonBlue {
      color: ${props => props.theme.colors.claytonBlue};
  }

  .block-content_sidebar {
    border-bottom: solid 1px ${props => props.theme.colors.blue10};

    > .inner {
      > .content {
        @media (min-width: ${props => props.theme.breakpoints.desktop}) {
          margin-left: 104px;
        }

        .block-content {
          overflow: visible;
          padding: 2rem 0;

          &:first-child {
            padding-top: 0;
          }

          &:last-child {
            padding-bottom: 0;
          }

          .inner {
            margin-left: initial;
          }

          .links {
            display: flex;
            flex-direction: row;

            a {
              margin: 0 0.5rem;

              &:first-child {
                margin-left: 0;
              }

              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }

      > .sidebar {
        .block-content {
          padding: 0 0 0 2rem;

          @media (min-width: ${props => props.theme.breakpoints.desktop}) {
            margin-top: 5.5rem;
          }
        }
      }
    }
  }
`;
